var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderFinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.245 29.7096C11.1817 29.7096 7.73777 28.2981 4.91313 25.4752C2.09018 22.6539 0.678711 19.2108 0.678711 15.1458C0.678711 11.0809 2.09018 7.6369 4.91313 4.81395C7.73607 1.99101 11.18 0.580384 15.245 0.582079C19.31 0.583773 22.7531 1.99524 25.5743 4.81649C28.3956 7.63775 29.8071 11.0809 29.8088 15.1458C29.8088 16.9114 29.4961 18.6203 28.8709 20.2724C28.2456 21.9245 27.4238 23.3376 26.4055 24.5119L41.4242 39.5255C41.6614 39.7627 41.7885 40.055 41.8054 40.4024C41.8207 40.7463 41.6936 41.0539 41.4242 41.325C41.1531 41.5961 40.8531 41.7317 40.5244 41.7317C40.1957 41.7317 39.8958 41.5961 39.6247 41.325L24.6085 26.3088C23.3377 27.3916 21.8762 28.2295 20.2241 28.8225C18.572 29.4156 16.9115 29.7121 15.2425 29.7121M15.2425 27.1705C18.6144 27.1705 21.4619 26.0098 23.785 23.6884C26.1064 21.367 27.2671 18.5195 27.2671 15.1458C27.2671 11.7722 26.1072 8.92552 23.7875 6.60583C21.4678 4.28613 18.6212 3.12544 15.2475 3.12375C11.8739 3.12375 9.02639 4.28444 6.705 6.60583C4.38361 8.92722 3.22207 11.7739 3.22038 15.1458C3.21868 18.5178 4.37938 21.3644 6.70246 23.6858C9.02554 26.0072 11.8722 27.1679 15.2425 27.1679",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderFinder);
export default __webpack_public_path__ + "static/media/header_finder.633ec998c58d6a38071326ccbb21f96d.svg";
export { ForwardRef as ReactComponent };